import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        object_id: '',
        object_type: '',
        user_id: 0,
        account_id: 0,
        project_id: 0,
        notification_time: 0,
        snooze_time: 0,
        delete_time: 0,
        summary: '',
        comment_data: '',
        is_read: false,
        is_archived: false,
        is_important: false,
        is_followed: false
    }
});